import { OptionValue } from './OptionValue';
export class Lookup {
    id:string;
    Name: string;
    EntityName:string;

    constructor(id:string,EntityName:string){
        this.id = id;
        this.EntityName = EntityName

    }

    
}


